import script from "./HeaderMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderMenu.vue?vue&type=style&index=0&id=1992603a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1992603a"]])

export default __exports__